import React, { useContext } from 'react'
import type { Id } from '@ppwr/convex/_generated/dataModel'

export interface GameContext {
  // Allowing undefined here to support and recognize non-game routes
  gameId: Id<'games'> | undefined
  userId: string
}

export const GameContainerContext = React.createContext<GameContext | undefined>(undefined)

export const useGameContext = () => {
  const ctx = useContext(GameContainerContext)

  if (!ctx) {
    throw new Error('useGameState called outside provider')
  }

  return ctx
}

// Lounge theme context — provided by GameContent, consumed by card components
export const LoungeThemeContext = React.createContext<{ cardBackColor: string | null }>({ cardBackColor: null })

export const useLoungeTheme = () => useContext(LoungeThemeContext)
